import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign } from 'lucide-react';

function formatMonthYear(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('es', { month: 'short', year: 'numeric' });
  } catch { return ''; }
}

function getProjectLabel(projectId, projects) {
  if (!projectId) return 'General';
  const p = projects.find(pr => pr.id === projectId);
  if (!p) return 'General';
  const words = p.title.trim().split(/\s+/).slice(0, 2).join(' ');
  return words.length > 18 ? words.slice(0, 18) + '...' : words;
}

export function ExpensesChart({ allExpenses, projects = [] }) {
  const expenses = allExpenses?.expenses || [];
  const total = allExpenses?.total || 0;

  return (
    <Card data-testid="expenses-panel">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <DollarSign className="h-4 w-4" />
          Gastos
          {total > 0 && (
            <span className="text-xs font-normal text-muted-foreground ml-auto">Total: ${total.toFixed(2)}</span>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {expenses.length === 0 ? (
          <p className="text-sm text-muted-foreground">Sin gastos registrados.</p>
        ) : (
          <div className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
            {expenses.map((expense) => (
              <div key={expense.id} className="flex items-start justify-between gap-2 py-1 border-b border-border/30 last:border-0" data-testid={`expense-hist-${expense.id}`}>
                <div className="min-w-0 flex-1">
                  <span className="text-sm block truncate">{expense.concepto || expense.description || 'Gasto'}</span>
                  <span className="text-[0.6rem] text-muted-foreground">
                    {getProjectLabel(expense.project_id, projects)}
                  </span>
                </div>
                <div className="text-right shrink-0">
                  <span className="text-sm font-semibold">${expense.amount?.toFixed(2)}</span>
                  <span className="text-[0.6rem] text-muted-foreground block">
                    {formatMonthYear(expense.day_date)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
